import React, { Component } from 'react'

export default class Hidden extends Component {
  render() {
    const { formikField } = this.props

    return (
      <input
        className="hidden"
        type="hidden"
        {...formikField} />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/Hidden.js